import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem("cookie-consent", "refused");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border py-4 px-6 animate-slide-up"
      role="dialog"
      aria-label="Bannière de consentement aux cookies"
    >
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-muted-foreground text-center md:text-left">
          Ce site utilise des cookies pour améliorer votre expérience de navigation. En continuant, vous acceptez notre{" "}
          <Link to="/politique-confidentialite" className="text-primary underline hover:text-primary/80">
            politique de confidentialité
          </Link>
          .
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={handleRefuse}
            className="px-6 py-2 text-sm font-medium text-foreground border border-border rounded hover:bg-muted transition-colors min-h-[44px]"
            aria-label="Refuser les cookies"
          >
            Refuser
          </button>
          <button
            onClick={handleAccept}
            className="px-6 py-2 text-sm font-medium text-primary-foreground bg-primary rounded hover:bg-primary/90 transition-colors min-h-[44px]"
            aria-label="Accepter les cookies"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
